import { Link } from 'gatsby';
import React from 'react';
import { menu } from '../constants/menu';
import { socialLinks } from '../constants/socialLinks';
import { FooterStyles } from '../styles/FooterStyles';
import Logo from './Logofooter';
import ParagraphText from './typography/ParagraphText';

function Footer() {
  return (
    <FooterStyles>
      <div className="container">

        <div className='horizontal'>
            <Logo />
        <ParagraphText className="footer__text">
        fatwa.so waa website waxbarasho oo laga heli karo su'aalo iyo jawaabo diini ah,oo af Soomaali ku qoran oo qaar ka mid ah culimada Soomaaliyeed ay ka jawaabayaan.
        </ParagraphText>
        <ul className="footer__menuList">
          {menu.map((item) => (
            <li key={item.path}>
              <Link to={item.path}>{item.title}</Link>
            </li>
          ))}
        </ul>
        </div>
        <ul className="footer__socialList">
          {socialLinks.map((item) => (
            <li key={item.name}>
              <a href={item.url}>{item.icon}</a>
            </li>
          ))}
        </ul>
      
      
        <ParagraphText className="copyright">
          © Fatwa {new Date().getFullYear()}. All rights
          reserved
        </ParagraphText>
      </div>
    </FooterStyles>
  );
}

export default Footer;
